import { api } from "@/lib/api";

export async function adminListUsers(params = {}) {
  const { data } = await api.get("/admin/users", { params });
  return data;
}

export async function adminUserOptions() {
  const { data } = await api.get("/admin/users/options");
  return data;
}

export async function adminUpdateUser(id, patch) {
  const { data } = await api.patch(`/admin/users/${id}`, patch);
  return data.user;
}

export async function adminDeleteUser(id) {
  await api.delete(`/admin/users/${id}`);
}

export async function adminSummary() {
  const { data } = await api.get("/admin/moderation/summary");
  return data;
}
